import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UNASSIGNED_BOXES_FEATURE_KEY } from '../keys';
import { UnassignedBoxesState } from '../reducers/unassigned-boxes.reducer';

const selectState = createFeatureSelector<UnassignedBoxesState>(UNASSIGNED_BOXES_FEATURE_KEY);

export const selectBoxes = createSelector(selectState, (state: UnassignedBoxesState) => state.boxes);
export const selectPage = createSelector(selectState, (state: UnassignedBoxesState) => state.page);
export const selectHasMore = createSelector(selectState, (state: UnassignedBoxesState) => state.hasMore);
export const selectLoaded = createSelector(selectState, (state: UnassignedBoxesState) => state.loaded);
export const selectLoading = createSelector(selectState, (state: UnassignedBoxesState) => state.loading);
export const selectSaving = createSelector(selectState, (state: UnassignedBoxesState) => state.saving);
export const selectSaved = createSelector(selectState, (state: UnassignedBoxesState) => state.saved);
